import React from "react";
import { useTranslation } from "react-i18next";
import { Caption1 } from "@activecollab/components";
import "./Form/InvoiceObjectItemsTable.css";
import classNames from "classnames";
import PropTypes from "prop-types";
import { PublicInvoiceObjectItemRow } from "~/components/InvoiceObject/Form/PublicInvoiceObjectItemRow";
import { PublicInvoiceObjectSubtotalPreview } from "~/components/InvoiceObject/Form/PublicInvoiceObjectSubtotalPreview";

export const PublicInvoiceObjectItemsTable = ({ items, item, className, currency }) => {
  const { t } = useTranslation();

  return (
    <div className={classNames("invoice_item_wrapper", className)}>
      <table className={classNames("invoice_item_table tw-w-full")}>
        <thead>
          <tr>
            <th className="order">
              <Caption1
                className="tw-w-full"
                color="tertiary"
                weight="bold"
                align="center"
              >
                #
              </Caption1>
            </th>
            <th className="description">
              <Caption1
                className="tw-w-full"
                color="tertiary"
                weight="bold"
              >
                {t("Description")}
              </Caption1>
            </th>
            <th className="quantity numeric">
              <Caption1
                className="tw-w-full"
                color="tertiary"
                weight="bold"
                align="right"
              >
                {t("Qty")}
              </Caption1>{" "}
            </th>
            <th className="cost numeric">
              <Caption1
                className="tw-w-full"
                color="tertiary"
                weight="bold"
                align="right"
              >
                {t("Cost")}
              </Caption1>
            </th>
            <th className="amount numeric">
              <Caption1
                className="tw-w-full"
                color="tertiary"
                weight="bold"
                align="right"
              >
                {t("Amount")}
              </Caption1>
            </th>
          </tr>
        </thead>
        <tbody>
          {items.map((invoice_item, index) => {
            return (
              <PublicInvoiceObjectItemRow
                key={`invoice-row-${invoice_item.id}`}
                index={index}
                item={invoice_item}
                currency={currency}
              />
            );
          })}

          <tr>
            <td className="tw-w-full">
              <PublicInvoiceObjectSubtotalPreview
                items={items}
                item={item}
                currency={currency}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

PublicInvoiceObjectItemsTable.propTypes = {
  items: PropTypes.array,
  item: PropTypes.object.isRequired,
  className: PropTypes.string,
  currency: PropTypes.object,
};

PublicInvoiceObjectItemsTable.defaultProps = {
  items: [],
  currency: {},
};

PublicInvoiceObjectItemsTable.displayName = "PublicInvoiceItemsTable";
